export const LogoHustleUpSmall: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.52933 2.33929L5.02146 7.15953H13.7149L16.8413 1.14969C16.9863 0.871488 16.784 0.53891 16.4706 0.53891H10.4952C9.24826 0.53891 8.10488 1.2329 7.52933 2.33929ZM3.50041 10.7457L0.373734 16.7553C0.228968 17.0336 0.430863 17.3663 0.744467 17.3663H6.71983C7.96685 17.3663 9.11018 16.6721 9.68573 15.5659L12.1936 10.7457H3.50041Z"
        fill={props.color}
      />
    </svg>
  )
}
